export class DeleteContractorFileRequest {

    _id; // number,

    constructor(values) {
        this._id = values.id;
    }

    id() {
        return this._id;
    }
}



// WEBPACK FOOTER //
// ./src/app/documentary-library/list/webservices/delete-documentary-library/DeleteContractorFileRequest.js